//@flow
import React from 'react';
import {Button, makeStyles} from '@material-ui/core';
import {Link} from 'react-router-dom';

import {Add} from '@material-ui/icons';
import {colors} from '../../../../../assets/styles/colors';
import {useIsFeatureInTier} from '../../../../../utils/component';
import {useTierRestrictionActions} from '../../../../TierRestriction/utils';

import SwitchableSection from '../../../../../elements/SwitchableSection';
import {NEW_BANNER_GROUP_ID} from '../../../utils/home-page-sections/constants';

const useStyles = makeStyles(theme => ({
  addBannerButton: {
    textTransform: 'none',
    display: 'flex',
    alignItems: 'center',
    gap: '1rem',
    color: colors.grey500,
    border: `2px dashed ${colors.grey500}`,
    borderRadius: '.75rem',
    paddingBlock: '.85rem',
  },
  bannerList: {
    marginTop: '1rem',
    display: 'flex',
    flexDirection: 'column',

    '& > *': {
      borderBottom: `1px solid ${colors.grey300}`,
    },

    '& > *:last-child': {
      borderBottom: 'none',
    },
  },
  loader: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '1rem',
  },
  disabledRoot: {
    background: colors.grey300,
  },
}));

// const MAX_BANNER_GROUPS = 5;

export default function EmptyBannerGroupSection() {
  const classes = useStyles();

  const hasBannerFeature = useIsFeatureInTier('BANNER');
  const {showTierRestrictionModal} = useTierRestrictionActions();

  return (
    <SwitchableSection title="Banners" disabled={!hasBannerFeature}>
      <Button
        fullWidth
        className={classes.addBannerButton}
        component={Link}
        to={`/my-store/pages/home-page/banner/${NEW_BANNER_GROUP_ID}/new`}
        onClick={e => {
          if (!hasBannerFeature) {
            e.preventDefault();
            showTierRestrictionModal();
          }
        }}
      >
        <Add />
        Agregar nuevo banner
      </Button>
    </SwitchableSection>
  );
}
